import { createSlice } from "@reduxjs/toolkit";

const initialState = { header: "" };

const HeaderSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setHeader(state, action) {
      state.header = action.payload;
    },
  },
});

export const showHeaderAction = HeaderSlice.actions;

export default HeaderSlice.reducer;
